import {combineEpics, Epic, ofType} from "redux-observable"
import {getType} from "typesafe-actions"
import {
    catchError,
    map,
    mergeMap,
    switchMap,
    withLatestFrom,
} from "rxjs/operators"
import {from, merge, of} from "rxjs"
import axios from "axios"
import {
    getDatabaseAction,
    getDatabaseSuccessAction,
    getShowDisclaimerAction,
    getShowDisclaimerSuccessAction,
    saveTermsAction,
    saveTermsSuccessAction,
} from "../actions/core.actions"
import {errorAction} from "../../metstat/redux/refdb.actions"

const getDatabase: Epic = (action$) =>
    action$.pipe(
        ofType(getType(getDatabaseAction)),
        mergeMap(() =>
            from(axios.get<string>(`/api/info`)).pipe(
                map(({data}) => getDatabaseSuccessAction(data))
            )
        )
    )
const showDisclaimer: Epic = (action$, state$) =>
    action$.pipe(
        ofType(getType(getShowDisclaimerAction)),
        withLatestFrom(state$),
        switchMap(() => from(axios.get<any>("/api/showDisclaimer"))),
        map((response) => {
            return getShowDisclaimerSuccessAction(response.data.item as boolean)
        }),
        catchError((error, caught) => merge(of(errorAction(error)), caught))
    )
const terms: Epic = (action$, state$) =>
    action$.pipe(
        ofType(getType(saveTermsAction)),
        withLatestFrom(state$),
        switchMap((action) =>
            from(axios.post<any>("/api/terms", action[0].payload))
        ),
        map((response) => {
            return saveTermsSuccessAction(response.data)
        }),
        catchError((error, caught) => merge(of(errorAction(error)), caught))
    )

export default combineEpics(getDatabase, showDisclaimer, terms)
